import { FunctionComponent } from 'react';
import './features.scss';
import A from '../shared/html-tags/a';
import { Helmet } from 'react-helmet-async';

export type Props = {};

const FeaturesOverview: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------

  return (
    <>
      <Helmet>
        <title>PS IMAGO PRO - Funktionenübersicht</title>
        <meta
          name="description"
          content="Entdecken Sie die umfassenden Funktionen von PS IMAGO PRO, die Ihnen helfen, Ihre Daten effizient zu verwalten, zu analysieren und zu präsentieren."
        />
        <meta
          name="keywords"
          content="PS IMAGO PRO, Funktionen, Datenmanagement, Datenanalyse, Reporting, Predictive Solutions"
        />
        <link rel="canonical" href="https://predictivesolutions.2x4.de/de/features" />
      </Helmet>
      <div>
        {/* =========================================================================================== */}

        <div className="features-overview">
          <div className="features-overview-inner">
            <div className="odd">
              <img
                src="/img/features/1/features-1-management.png"
                alt=""
                className="feature-icon"
              />
            </div>
            <A language="de" href="/de/features/management" className="features1">
              Effiziente Datenaufbereitung
            </A>
            <A language="de" href="/de/features/management" className="features1">
              Multi-Source Datenimport
            </A>
            <A language="de" href="/de/features/management" className="features1">
              Datenoptimierung
            </A>
            <A language="de" href="/de/features/management" className="features1">
              Umfassendes Datenmanagement
            </A>
          </div>
          <div className="features-overview-inner">
            <div className="even">
              <img src="/img/features/2/features-2-analysis.png" alt="" className="feature-icon" />
            </div>
            <A language="de" href="/de/features/analysis" className="features2">
              Umfassende Datenanalyse
            </A>
            <A language="de" href="/de/features/analysis" className="features2">
              Statistische Beschreibung
            </A>
            <A language="de" href="/de/features/analysis" className="features2">
              Analyse-Algorythmen
            </A>
          </div>
          <div className="features-overview-inner">
            <div className="odd">
              <img
                src="/img/features/3/features-3-report-creation.png"
                alt=""
                className="feature-icon"
              />
            </div>
            <A language="de" href="/de/features/reporting" className="features3">
              Klare Ergebnispräsentation
            </A>
            <A language="de" href="/de/features/reporting" className="features3">
              Berichterstellung
            </A>
            <A language="de" href="/de/features/reporting" className="features3">
              Stilvolle Layouts
            </A>
            <A language="de" href="/de/features/reporting" className="features3">
              Dashboard- und Dokument-Modus
            </A>
          </div>
          <div className="features-overview-inner">
            <div className="even">
              <img
                src="/img/features/4/features-4-deployment1.png"
                alt=""
                className="feature-icon"
              />
            </div>
            <A language="de" href="/de/features/deployment" className="features4">
              Smarte Verteilung und Verwaltung
            </A>
            <A language="de" href="/de/features/deployment" className="features4">
              Berichterstattung
            </A>
            <A language="de" href="/de/features/deployment" className="features4">
              Korrektur und Anpassung
            </A>
            <A language="de" href="/de/features/deployment" className="features4">
              Übersicht und Feedback
            </A>
          </div>
          <div className="features-overview-inner">
            <div className="odd">
              <img src="/img/features/5/features-5-publish1.png" alt="" className="feature-icon" />
            </div>
            <A language="de" href="/de/features/publish" className="features5">
              Veröffentlichung und Automatisierung
            </A>
            <A language="de" href="/de/features/publish" className="features5">
              Cloud
            </A>
            <A language="de" href="/de/features/publish" className="features5">
              Autopilot
            </A>
            <A language="de" href="/de/features/publish" className="features5">
              Live Planung
            </A>
          </div>
        </div>
        <div style={{ textAlign: 'center', marginTop: '2rem' }}></div>
      </div>
    </>
  );
};

export default FeaturesOverview;
